// extracted by mini-css-extract-plugin
export default {"card":"FTUCompleted_card__8bhUQ","cardContent":"FTUCompleted_cardContent__qWO+C","icon":"FTUCompleted_icon__68i36"};